import React from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { styled } from '@mui/material';
import FieldSwitch from 'components/FormElements/FieldSwitch';

type FinalDealToggleBarProps = {
  fundIndex: number;
  finalDeal: boolean;
  setValue: UseFormSetValue<{ fundAllocations: Array<any> }>;
};

const FinalDealToggleBarContainer = styled('div')(({ theme }) => ({
  fontSize: theme.fontSizes?.regular,
  padding: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
}));

const FinalDealToggleBar: React.FC<FinalDealToggleBarProps> = ({
  fundIndex,
  finalDeal,
  setValue,
}) => {
  const handleFinalDealToggle = (checked: boolean) => {
    setValue(`fundAllocations.${fundIndex}.finalDeal`, checked);
  };

  return (
    <FinalDealToggleBarContainer>
      <div>Mark tranche as fully deployed ("Final deal") after submission?</div>
      <FieldSwitch
        checkedLabel=""
        uncheckedLabel=""
        checked={finalDeal}
        onChange={(e) => handleFinalDealToggle(e.target.checked)}
      />
    </FinalDealToggleBarContainer>
  );
};

export default FinalDealToggleBar;
